import type { GridContent, CellSection } from "./contentItemSchemas";
import { isRecord } from "./shared";
import { parseCellSection } from "./cell";
import {
  gridContentFieldsSchema,
  parseGridContentFromFields,
  parseWithRecord,
} from "./schemas";

export const parseGridContent = (
  item: unknown,
  formLabel?: string,
): GridContent => {
  const parsed = parseWithRecord(item, gridContentFieldsSchema);
  const cellsRaw: unknown[] = Array.isArray(parsed.cells) ? parsed.cells : [];
  const cellSingle: unknown = parsed.cell;
  const cells: CellSection[] =
    cellsRaw.length > 0
      ? cellsRaw.map((cell: unknown) => parseCellSection(cell))
      : isRecord(cellSingle)
        ? [parseCellSection(cellSingle)]
        : [];
  return parseGridContentFromFields(parsed, formLabel, cells);
};
